import { Meet } from "./Meet";
class DashBoardEndPoint extends Meet {
    constructor() {
        super("/DashBoards");
    }

    getThongKePhienHop = (year) => this.GetAllow(`/ThongKePhienHop?nam=${year}`)
}
export default new DashBoardEndPoint()